<template>
      <div no-body class="lku-item"> 
      <b-form-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-form-row>
      <b-input-group v-else>
          <b-input-group-append><span class="ml-2 pt-2 mr-1">Filter</span></b-input-group-append>
          <b-form-input v-model="tblData.itemcode" placeholder="Code" value="" @keyup.13.native="refresh()"></b-form-input>
          <b-form-input v-model="tblData.itemname" placeholder="Name" @keyup.13.native="refresh()" class="ml-1"></b-form-input>
          <b-form-input v-model="tblData.headcategory" placeholder="Head Category" value="" @keyup.13.native="refresh()"></b-form-input>
          <b-input-group-append>
                <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
          </b-input-group-append>
      </b-input-group>

      <b-table
          class="m-0"
          ref="tblItem"
          responsive striped hover small
          style="font-size:smaller;" 
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
          <!-- <template v-slot:cell(jasa)="data">
            <span v-if="(data.item.jasa==1)">Service</span>
            <span v-else>Material</span>
          </template> -->
        <template v-slot:cell(qtyAvail)="data">
          {{data.item.qtyAvail}} {{data.item.invunitom}}
        </template>

      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-item {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import item from "../../apis/logistic_trading";

export default {
  data() {
    return {
      fields: [
          {
            key: "partnumber",
            label: "Item Code",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Name",
            sortable: true
          },
          {
            key: "itemcategory",
            label: "Category",
            sortable: true

          },
          {
            key: "qtyAvail",
            label: "Qty Available",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "namaStore",
            label: "Store",
            sortable: true
          },
          

      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'itemname',
        sortDesc: false,
      },
      lkuLoading:false
    };
  },
  props: ['jasa'],
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.lkuLoading = false;
    },
    data: async function(ctx) {
      if(this.jasa){
        this.tblData.jasa = this.jasa; 
      }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      const items= await item.listavailable(this.tblData);    
      this.lkuLoading = false;
      return items;      

    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData.itemcode=  '';
        this.tblData.itemname=  '';
        this.tblData.headcategory=  '';
        this.refresh();
    },    
    refresh() {
      this.$refs.tblItem.refresh();
    }
  }
};
</script>
